export
const name: string = "CPlane";

export
const preproc: string = ``;

export
const declaration: string = `
    uniform bool u_plane_active;
    uniform bool u_clippable;
    uniform vec4 u_plane;
    uniform bool u_highlight_cut;
`;

export
const varyings: string = `
    varying vec3 v_plane_position;
    const vec3 clippingPlaneColor = vec3(1.0, 0.0, 0.0);
`;

export
const implementation: string = `
    bool resolveClippingPlane()
    {
        // Cutting plane
        if (u_plane_active && u_clippable) {
            float value = u_plane.x * v_plane_position.x + u_plane.y * v_plane_position.y + u_plane.z * v_plane_position.z + u_plane.w;
            if (value >= 0.0) {
                discard;
            }

            if (u_highlight_cut && value >= -0.025) {
                return true;
            }
        }

        return false;
    }
`;
